import { cva } from 'class-variance-authority'

const badgeVariants = cva(
  `
    inline-flex min-h-[20px] min-w-[20px] shrink-0 items-center justify-center gap-20 rounded-10 border
    border-transparent px-20 py-10 text-center font-body text-10 leading-20 font-400 tracking-20
    [&_svg]:pointer-events-none [&_svg]:shrink-0
    [&_svg:not([class*='size-'])]:size-[12px]
  `,
  {
    variants: {
      color: {
        gray: '',
        neutral: '',
        blue: '',
        green: '',
        orange: '',
        red: '',
        periwinkle: '',
        sky: '',
        mindaro: '',
        jasmine: '',
        peach: '',
      },
      emphasis: {
        subtle: '',
        solid: '',
      },
    },
    compoundVariants: [
      { color: 'gray', emphasis: 'subtle', class: 'bg-surface-neutral-inverse text-content-base-main' },
      { color: 'gray', emphasis: 'solid', class: 'bg-surface-neutral text-content-base-inverse' },
      {
        color: 'neutral',
        emphasis: 'subtle',
        class: 'border-line-base-basic bg-surface-base-hover text-content-base-main',
      },
      {
        color: 'neutral',
        emphasis: 'solid',
        class: 'border-line-base-basic bg-surface-base-inverse text-content-base-inverse',
      },
      { color: 'blue', emphasis: 'subtle', class: 'bg-surface-info-inverse text-content-base-main' },
      { color: 'blue', emphasis: 'solid', class: 'bg-surface-info-primary text-content-base-inverse' },
      { color: 'green', emphasis: 'subtle', class: 'bg-surface-success-inverse text-content-base-main' },
      { color: 'green', emphasis: 'solid', class: 'bg-surface-success-primary text-content-base-inverse' },
      { color: 'orange', emphasis: 'subtle', class: 'bg-surface-warning-inverse text-content-base-main' },
      { color: 'orange', emphasis: 'solid', class: 'bg-surface-warning-primary text-content-base-inverse' },
      { color: 'red', emphasis: 'subtle', class: 'bg-surface-danger-inverse text-content-base-main' },
      { color: 'red', emphasis: 'solid', class: 'bg-surface-danger-primary text-content-base-inverse' },
      { color: 'periwinkle', emphasis: 'subtle', class: 'bg-surface-decorative-1 text-content-decorative-main' },
      { color: 'periwinkle', emphasis: 'solid', class: 'bg-surface-base-inverse text-content-decorative-1' },
      { color: 'sky', emphasis: 'subtle', class: 'bg-surface-decorative-2 text-content-decorative-main' },
      { color: 'sky', emphasis: 'solid', class: 'bg-surface-base-inverse text-content-decorative-2' },
      { color: 'mindaro', emphasis: 'subtle', class: 'bg-surface-decorative-3 text-content-decorative-main' },
      { color: 'mindaro', emphasis: 'solid', class: 'bg-surface-base-inverse text-content-decorative-3' },
      { color: 'jasmine', emphasis: 'subtle', class: 'bg-surface-decorative-4 text-content-decorative-main' },
      { color: 'jasmine', emphasis: 'solid', class: 'bg-surface-base-inverse text-content-decorative-4' },
      { color: 'peach', emphasis: 'subtle', class: 'bg-surface-decorative-5 text-content-decorative-main' },
      { color: 'peach', emphasis: 'solid', class: 'bg-surface-base-inverse text-content-decorative-5' },
    ],
    defaultVariants: {
      color: 'gray',
      emphasis: 'subtle',
    },
  },
)

export { badgeVariants }
